import { LEGAL_DOCUMENTS } from "@shared/const/legal-documents";

const documents = [
  LEGAL_DOCUMENTS.consent,
  LEGAL_DOCUMENTS.consentPublication,
  LEGAL_DOCUMENTS.policy,
  LEGAL_DOCUMENTS.userAgreement,
];

export const LegalDocumentsLinks = ({ asListItems = false }) => {
  if (asListItems) {
    return documents.map((document) => (
      <li key={document.url}>
        <a href={document.url} target="_blank" rel="noreferrer">{document.label}</a>
      </li>
    ));
  }

  return documents.map((document) => (
    <a key={document.url} href={document.url} target="_blank" rel="noreferrer">
      {document.label}
    </a>
  ));
};
